<div id="homeBar" class="styleBar" #homeBar>
  <!-- <button mat-icon-button disableRipple class="buttonBar" (click)="resetNorth()"
    *ngIf="!homeComponent.activatedViewPanoramic">
    <mat-icon [ngStyle]="{'transform': 'rotate('+ compassRotation + 'deg)'}">explore</mat-icon>
  </button> -->

  <button mat-icon-button class="buttonBar" (click)="goHome()">
    <mat-icon>home</mat-icon>
  </button>
  <button mat-icon-button class="buttonBar" (click)="locate()">
    <mat-icon>my_location</mat-icon>
  </button>
  <button mat-icon-button class="buttonBar" (click)="zoomIn()">
    <mat-icon>add</mat-icon>
  </button>
  <!-- <div class="slidecontainer">
    <input type="range" min="0" max="23" [value]="mapService.getViewMap().zoom" class="rotated" #ref
      (input)="changeZoom(ref.value)">
  </div> -->
  <button mat-icon-button class="buttonBar" (click)="zoomOut()">
    <mat-icon>remove</mat-icon>
  </button>
</div>